import WishlistIcon from 'Component/WishlistIcon';
import {
    NavigationTabsComponent as SourceNavigationTabsComponent,
} from 'SourceComponent/NavigationTabs/NavigationTabs.component';
import {ReactElement} from 'Type/Common.type';
import {isSignedIn} from 'Util/Auth/IsSignedIn';

import {NavigationTabsMap} from './NavigationTabs.config';

import './NavigationTabs.override.style';

/** @namespace Steinkrueger/Component/NavigationTabs/Component */
export class NavigationTabsComponent extends SourceNavigationTabsComponent {
    stateMap: Record<string, Record<string, boolean>> = {
        [NavigationTabsMap.HOME_TAB]: {
            home: true,
        },
        [NavigationTabsMap.MENU_TAB]: {
            menu: true,
        },
        [NavigationTabsMap.CART_TAB]: {
            minicart: true,
        },
        [NavigationTabsMap.ACCOUNT_TAB]: {
            account: true,
        },
        [NavigationTabsMap.CHECKOUT_TAB]: {
            minicart: true,
        },
        [NavigationTabsMap.WISHLIST_TAB]: {
            wishlist: true,
        },
    };

    renderMap = {
        home: this.renderHomeButton.bind(this),
        menu: this.renderMenuButton.bind(this),
        wishlist: this.renderWishlistButton.bind(this),
        account: this.renderAccountButton.bind(this),
        minicart: this.renderMinicartButton.bind(this),
    };

    renderWishlistButton(isActive = false): ReactElement {
        const { onWishlistButtonClick } = this.props;
        const isLogged = isSignedIn();

        if (!isLogged) {
            return null;
        }

        return (
            <button
              key="wishlist"
              block="NavigationTabs"
              elem="Button"
              onClick={ onWishlistButtonClick }
              aria-label="Open wishlist page"
            >
                <WishlistIcon isActive={ isActive } />
            </button>
        );
    }
}

export default NavigationTabsComponent;
